import {IComponentOptions} from 'angular';
import {TSSchadenfallHerkunft} from '../../../models/enums/TSSchadenfallHerkunft';
import DVBernUtil from '../../../utils/DVBernUtil';

require('./dv-betrag.scss');

/**
 * Komponente fuer die Bestimmung des Anrechenbaren Schadens
 */
export class BetragComponentConfig implements IComponentOptions {
    transclude = false;
    bindings: any = {
        readonly: '<',
        ermittelterSchaden: '<',
        einkommensabzug: '<',
        vermoegenssabzug: '<',
        nichtBerechtigterAnteil: '<',
        anrechenbarerSchaden: '<',
        prozentsatz: '<',
        betragVorschlag: '<',
        beitrag: '<',
        importiertAbzugEV: '<',
        schadenfallherkunft: '<',
    };
    template = require('./dv-betrag.html');
    controller = DvBetragController;
    controllerAs = 'vm';
    require: any = {parentForm: '?^form'};
}

export class DvBetragController {
    static $inject = [];

    readonly: boolean;
    ermittelterSchaden: number;
    einkommensabzug: number;
    vermoegenssabzug: number;
    nichtBerechtigterAnteil: number;
    anrechenbarerSchaden: number;
    prozentsatz: number | undefined;
    betragVorschlag: string;
    beitrag: string;
    importiertAbzugEV: number | null;
    schadenfallherkunft: TSSchadenfallHerkunft | null;

    public useImportiertAbzugEV(): boolean {
        return DVBernUtil.isNotNullOrUndefined(this.schadenfallherkunft) && DVBernUtil.isNotNullOrUndefined(this.importiertAbzugEV) && this.importiertAbzugEV !== 0;
    }

    /* @ngInject */
    constructor() {
    }

}




// WEBPACK FOOTER //
// ./src/app/core/component/dv-betrag/dv-betrag.ts